<template>
  <div>
    <el-dialog
      :title="`${curUserInfo.fullName}（${curUserInfo.courseName}）${
        title[curUserInfo.curIndex]
      }`"
      :visible.sync="dialogVisible"
      width="870px"
      @close="closeDialog"
    >
      <StudyTime
        v-if="curUserInfo.curIndex === 0"
        :courseScoreId="curUserInfo.courseScoreId"
      />
      <KnowledgeOrDiscontinuousRunning
        v-if="curUserInfo.curIndex === 1 || curUserInfo.curIndex === 2"
        :courseScoreId="curUserInfo.courseScoreId"
        :infoStatus="curUserInfo.curIndex"
      />
      <!-- <GeneralTestScore
        v-if="curUserInfo.curIndex === 3"
        :courseScoreId="curUserInfo.courseScoreId"
      /> -->
      <!-- <IntegrityPerformanceOrHomeworkOrInteraction
        v-if="
          curUserInfo.curIndex === 4 ||
          curUserInfo.curIndex === 6 ||
          curUserInfo.curIndex === 7
        "
        :courseScoreId="curUserInfo.courseScoreId"
      /> -->
      <ClassAttendance
        v-if="curUserInfo.curIndex === 3"
        :courseScoreId="curUserInfo.courseScoreId"
        :batchId="curUserInfo.batchId"
      />
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <el-button
          v-if="curUserInfo.curIndex !== 0"
          type="primary"
          @click="prevIndex"
        >
          <i class="el-icon-arrow-left"></i> 上一项
        </el-button>
        <el-button type="primary" @click="closeDialog">返回</el-button>
        <el-button
          v-if="curUserInfo.curIndex !== 3"
          type="primary"
          @click="nextIndex"
        >
          下一项 <i class="el-icon-arrow-right"></i>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import StudyTime from './studyTime.vue'
import KnowledgeOrDiscontinuousRunning from './knowledgeOrDiscontinuousRunning.vue'
// import GeneralTestScore from './generalTestScore.vue'
// import IntegrityPerformanceOrHomeworkOrInteraction from './integrityPerformanceOrHomeworkOrInteraction.vue'
import ClassAttendance from './classAttendance.vue'
export default {
  components: {
    StudyTime,
    KnowledgeOrDiscontinuousRunning,
    // GeneralTestScore,
    // IntegrityPerformanceOrHomeworkOrInteraction,
    ClassAttendance,
  },
  props: ['curUserInfo'],
  data() {
    return {
      title: [
        '学习时长',
        '知识点练习',
        '阶段作业成绩',
        '课堂出勤情况',
        '诚信表现',
        '综合测评成绩',
        '作业完成情况',
        '互动完成情况',
      ],
      dialogVisible: true,
    }
  },
  methods: {
    prevIndex() {
      this.$emit('prevIndex')
    },
    nextIndex() {
      this.$emit('nextIndex')
    },
    closeDialog() {
      if (this.curUserInfo.isGeneral) {
        this.$emit('closeLearningOutcomeDetail', this.curUserInfo.courseScoreId)
      } else {
        this.$emit('closeLearningOutcomeDetail')
      }
    },
  },
}
</script>

<style>
</style>